// LIBRERIE/IMPORTS
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouseChimneyUser, faPenRuler, faUserTie } from "@fortawesome/free-solid-svg-icons";

const ServicesSection: React.FC = () => {
    const { t } = useTranslation();

    const serviceCrads = [
        {
            icon: <FontAwesomeIcon icon={faHouseChimneyUser} />,
            title: t('homePage.servicesSection.card1.title'),
            description: t('homePage.servicesSection.card1.para')
        },
        {
            icon: <FontAwesomeIcon icon={faPenRuler} />,
            title: t('homePage.servicesSection.card2.title'),
            description: t('homePage.servicesSection.card2.para')
        },
        {
            icon: <FontAwesomeIcon icon={faUserTie} />,
            title: t('homePage.servicesSection.card3.title'),
            description: t('homePage.servicesSection.card3.para')
        }
    ]

    return (
        <section id="services-section" className="space-pb">
            <h2 className="text-center py-4 mb-0">{t('homePage.servicesSection.title')}</h2>
            <div className="container-fluid w-special">
                <div className="row justify-content-center mt-4">
                    {serviceCrads.map((service, index) => (
                        <div className="col-12 col-md-6 col-lg-4" key={index}>
                            <div className="service-card text-center">
                                <div className="mb-2 position-relative">
                                    <img src="/assets/images/nuvola.png" alt=""/>
                                    <i>{service.icon}</i>
                                </div>
                                <h4>{service.title}</h4>
                                <p>{service.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="row mt-4">
                    <div className="col-12 text-center">
                        <Link to={'/servizi'} title={t('homePage.servicesSection.btnTitle') as string} className="btn-primary">
                            {t('homePage.servicesSection.btnText')}
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServicesSection;